/**
 * 전체 페이지 진입 시 1회 실행: Cache API·Service Worker 잔여물 제거.
 * - HTML/JS는 서버 Cache-Control이 최종이나, 예전 SW·캐시가 남은 경우 갱신을 막는 것을 완화한다.
 * - 로그인 등 localStorage/sessionStorage는 건드리지 않는다.
 */
export async function clearClientCachesAndServiceWorkers() {
  if (import.meta.env.VITE_DISABLE_CLIENT_CACHE_RESET === 'true') {
    return
  }
  try {
    if (typeof caches !== 'undefined' && caches.keys) {
      const keys = await caches.keys()
      await Promise.all(keys.map((name) => caches.delete(name)))
    }
  } catch (_e) {
    /* ignore */
  }
  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((reg) => reg.unregister()))
    }
  } catch (_e) {
    /* ignore */
  }
}
